import { Injectable } from "@nestjs/common";
import { AssetsSaleDto } from "../dto/asset-sale.dto";
import { AssetsSale } from "./asset-sale.entity";

@Injectable()
export class AssetsSaleAdapter {
    public convertDtoToEntity(assetSaleDto: AssetsSaleDto, isUpdate: boolean = false): AssetsSale {
        const assetsSale = new AssetsSale();

        assetsSale.assetSaleId = assetSaleDto.assetSaleId;
        assetsSale.assetId = assetSaleDto.assetId
        assetsSale.approvedBy = assetSaleDto.approvedBy;
        assetsSale.assetSaleCost = assetSaleDto.assetSaleCost;
        assetsSale.status = assetSaleDto.status;
        assetsSale.reason = assetSaleDto.reason;
        assetsSale.isActive = assetSaleDto.isActive == undefined ? true : assetSaleDto.isActive;

        return assetsSale;
    
    }

    public convertEntityToDto(assetSale:AssetsSale) : AssetsSaleDto{
        const assetSaleDto = new AssetsSaleDto;
        assetSaleDto.assetSaleId = assetSale.assetSaleId;
        assetSaleDto.assetId = assetSale.assetId;
        assetSaleDto.approvedBy = assetSale.approvedBy;
        assetSaleDto.assetSaleCost = assetSale.assetSaleCost;
        assetSaleDto.createdAt = assetSale.createdAt;
        assetSaleDto.createdUser = assetSale.createdUser;
        assetSaleDto.status = assetSale.status;
        assetSaleDto.reason = assetSale.reason;
        assetSaleDto.isActive = assetSale.isActive;
        assetSaleDto.updatedAt = assetSale.updatedAt;
        assetSaleDto.updatedUser = assetSale.updatedUser;
        assetSaleDto.versionFlag = assetSale.versionFlag;
        return assetSaleDto;
        
    }

}